import cc from "classnames"

interface ProfilePicturePlaceholderProps {
  height: number
  width: number
  user?: Domain.Shared.DataTransferObjects.UserData
  font_size?: string
}

const ProfilePicturePlaceholder = (props: ProfilePicturePlaceholderProps): JSX.Element => {
  const getInitials = (user?: Domain.Shared.DataTransferObjects.UserData) => {
    if (!user || (!user.first_name && !user.last_name)) return "A"

    const firstLetter = user?.first_name?.toUpperCase().substring(0, 1) ?? ""
    const secondLetter = user?.last_name?.toUpperCase().substring(0, 1) ?? ""

    return `${firstLetter}${secondLetter}`
  }

  return (
    <div className="bg-neutral-200 flex" style={{ width: props.width, height: props.height }}>
      <div className={cc("text-neutral-300 m-auto", props.font_size)}>{getInitials(props.user)}</div>
    </div>
  )
}

export default ProfilePicturePlaceholder
